import { Box, styled } from "@mui/material";

export const StyledContainer = styled(Box)(({ theme }) => ({
  background: theme.palette.common.white,
  height: "90%",
  padding: theme.spacing(14, 8),
  borderRadius: theme.spacing(2),
  margin: theme.spacing(2, 4),
}));
